import { getGlobalSettings } from "./settings.js"
import { InstanceLoader, BaseComponentProps } from "./property_types.js"
import { Helper } from "../core/util/helper.js";
import { Config } from "../core/config/config.js";
import React from "react";
import axios from "axios";

export var httpService: IHttpService;

export var InnoCmp: { [id: string]: RegisteredComponent } = {};

interface RegisteredComponent {
    component: any,
    editorMetadata: any,
    listProperties: any,
    showInAddNewComponentMenu: any,
    componentType: any,
    isField: boolean
}

interface IHttpService {
    get(url: any, data: any, callback: any, failCallback?: any, isNotStatisticController?: boolean);
    postJson(url: any, params: any, callback: any, failCallback?: any, urlParams?: any, isNotStatisticController?: boolean)
    downloadFileWithPost(url: any, params: any, callback: any, failCallback?: any, urlParams?: any, isNotStatisticController?: boolean)
}

export function generateColumnName(text: string): string {
    var hash = 0, i, chr, len;
    if (!text || text.length === 0) return "col" + hash;
    for (i = 0, len = text.length; i < len; i++) {
        chr = text.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
    }
    return "col" + Math.abs(hash);
}

export function getQueryParamsFromSearch(): object {
    const a = window.location.search.split('?')[1];
    if (!a) {
        return {};
    }

    return parseJQueryParams(a);
}

function parseJQueryParams(query) {
    var query_string = {};
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        pair[0] = decodeURIComponent(pair[0]);
        pair[1] = decodeURIComponent(pair[1]);
        // If first entry with this name
        if (typeof query_string[pair[0]] === "undefined") {
            query_string[pair[0]] = pair[1];
            // If second entry with this name
        } else if (typeof query_string[pair[0]] === "string") {
            var arr = [query_string[pair[0]], pair[1]];
            query_string[pair[0]] = arr;
            // If third or later entry with this name
        } else {
            query_string[pair[0]].push(pair[1]);
        }
    }
    return query_string;

}

httpService = {
    get: function (url, data, callback, failCallback, isNotStatisticController: boolean) {
        const basePath = isNotStatisticController ? "" : getWebApiControllerPath();
        axios.get(basePath + url, { params: data })
            .then((response) => {
                callback && callback(response.data)
            })
            .catch(() => {
                failCallback && failCallback();
            });
    },

    postJson: function (url, params, callback, failCallback, urlParams?: any, isNotStatisticController?: boolean) {
        if (urlParams) {
            url += '?' + $.param(urlParams);
        }
        const basePath = isNotStatisticController ? "" : getWebApiControllerPath();
        axios
            .post(basePath + url, JSON.stringify(params, stringifyReplacer), { headers: { 'Content-Type': 'application/json' } })
            .then((result) => {
                callback && callback(result.data);
            })
            .catch(() => {
                failCallback && failCallback();
            });
    },

    downloadFileWithPost: function (url, params, callback, failCallback, urlParams?: any, isNotStatisticController?: boolean) {
        if (urlParams) {
            url += '?' + $.param(urlParams);
        }
        const basePath = isNotStatisticController ? "" : getWebApiControllerPath();
        axios
            .post(basePath + url, JSON.stringify(params, stringifyReplacer), { headers: { 'Content-Type': 'application/json' }, responseType: 'blob' })
            .then((result) => {
                callback && callback(result.data);
            })
            .catch(() => {
                failCallback && failCallback();
            });
    }
}

function getWebApiControllerPath(): string {
    const settings = getGlobalSettings().GetSettings();
    return Config.baseUrl + "Statistic/";
}

function stringifyReplacer(key, value) {

    if (key.indexOf('_!!') == 0) {
        return undefined;
    }
    else return value;
}


export enum ComponentType {
    InputComponent = 1,
    DisplayComponent = 2
};

export var addComponentToIndex = function (type: any, component: any, editorMetaData: any, listProperties: any, showInAddNewComponentMenu: any, componentType: ComponentType, isfield: boolean = false) {
    InnoCmp[type] = { component: component, editorMetadata: editorMetaData, listProperties: listProperties, showInAddNewComponentMenu: showInAddNewComponentMenu, componentType: componentType, isField: isfield }
}

export var getEditorMetadata = function (type) {
    var cmp = InnoCmp[type];
    if (cmp) {
        return cmp.editorMetadata;
    }
    return null;
}

export var getMetaDataForComponent = function (editorElement): BaseComponentProps {
    const element = getEditorMetadata(editorElement.type);
    if (element) {
        const instance = InstanceLoader.getInstance(element, null, null);
        instance.hydrateFromJS(editorElement);
        return instance as BaseComponentProps;
    }
}

export interface IContextProps {
    registerComponent(componentId: string, requiredServices: string[], callback: any, additionalParams?: any, datasource?: any);
    unregisterComponent(componentId: string);
    loadMissingData(parameters: {}, additionatParams?: {});
    loadChildData(parameters: {}, additionatParams?: {});
    reloadAllData(parameters: any);
    reloadCurrentData();
    variables: any;
    openSheet?: any;
    drillDownObject?: any;
    fullHeightLayout?: boolean;
}


export interface IComponentProps {
    uid: any;
    settings: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: any
}

export var getComponentBySettings = function (settings, values, that, queryParameter, context: IContextProps, rootPropertyPath, extendedUid) {
    const cmp = InnoCmp[settings.type];

    if (!cmp) {
        return React.createElement('div', { style: { background: "red" } }, "Component of type " + settings.type + " not found");
    }

    var metadata = getMetaDataForComponent(settings);

    const composedId = settings.uid + extendedUid || '';
    const settingsObject: IComponentProps = {
        uid: composedId,
        settings: settings,
        values: values,
        queryParameter: queryParameter,
        onTextChange: that.handleTextChange,
        context: context,
        rootPropertyPath: rootPropertyPath,
        extendedUid: extendedUid,
        metadataSettings: metadata
    };

    const width = settingsObject.settings.width;
    const span = "span " + (width || "12");
    if (metadata) {
        metadata.width = 0;
    }

    const element = React.createElement(cmp.component, settingsObject);
    let style: React.CSSProperties = {};
    if (settings['_!!_isSelectedInEditor']) {
        style = { borderStyle: "dashed", borderWidth: "3px", borderColor: "lightblue", overflow: "auto", gridColumn: span };
    }
    else {

        style = { gridColumn: span };
    }

    if (context?.fullHeightLayout) {
        style.height = "100%";
    }
    return React.createElement('div', { key: composedId, style: style }, element);

}

export function getDrillDownObject(): any {
    return {
        requestDrillDown: function (statisticId, params, dataItem) {

            this.onDrillDown(statisticId, params, dataItem);
        },
        onDrillDown: function () {
        }
    }
}

export var StatisticHelper = StatisticHelper || {};
StatisticHelper.pivoteData = function (pivotProperties, data): any {
    try {
        if (!pivotProperties) {
            return { pivotizedData: data };
        }

        var pivotField = pivotProperties.pivotField;
        var groupingFields = pivotProperties.groupingFields;

        if (!pivotField) {
            return { pivotizedData: data };
        }
        var that = this;

        const groupedByPivotField = groupBy(data, (value) => {
            return value[pivotField];
        });

        const groupByPivotElement = Object.keys(groupedByPivotField)
        var groupped = groupBy(data, (value) => {
            let key = '';
            groupingFields.map((field) => {
                key += value[field.field] + '#';
            });
            return key;
        });

        const mapped = Object.keys(groupped).map((key) => {
            const value = groupped[key];
            var obj = {};
            groupingFields.map(function (field) {
                obj[field.field] = value[0][field.field];
            });

            var allProperties = that.getObjectProperties(value[0]);
            for (var i = 0; i < groupByPivotElement.length; i++) {
                for (var f = 0; f < allProperties.length; f++) {
                    obj[allProperties[f] + "_" + groupByPivotElement[i]] = null;
                }
            }

            for (var u = 0; u < allProperties.length; u++) {
                obj[allProperties[u]] = value[0][allProperties[u]];
                for (var x = 0; x < value.length; x++) {
                    obj[allProperties[u] + "_" + value[x][pivotField]] = value[x][allProperties[u]];
                }
            }

            return obj;
        });
        let sorted = mapped;
        if (Array.isArray(pivotProperties.sortFields)) {
            pivotProperties.sortFields.map(function (field) {
                sorted = sorted.sort(function (a: any, b: any) {
                    if (Helper.isNumber(a)) {
                        return a - b;
                    }
                    return ('' + a).localeCompare(b);
                });
            });
        }

        return { pivotizedData: sorted, pivotKeys: groupByPivotElement };
    } catch (ex) {
        return { pivotizedData: [], pivotKeys: {} };
    }

};

StatisticHelper.getObjectProperties = function (obj) {
    var allProperties = [];
    for (var name in obj) {
        if (obj.hasOwnProperty(name)) {
            allProperties.push(name);
        }
    }
    return allProperties;
};

var groupBy = function (xs: any[], keyFunction): object {
    return xs.reduce((rv, x) => {
        const key = keyFunction(x);
        (rv[key] = rv[key] || []).push(x);
        return rv;
    }, {});
};

export class ApiControllerBase {
    protected canceled: boolean = false;

    protected invokeCallback = (callback, result) => {
        if (!this.canceled) {
            callback && callback(result);
        }
    }

    public cancel = () => {
        this.canceled = true;
    }
}